import req from '@/api/req'
export default {
  fetchLibrary: req,
  // context: {
  //   searchComponent: () => import('./components/test')
  // },
  context: {
    qs:false,
    globalHooks: {
      beforeQuery (params) {
        const { pageNum, pageSize, finderId, qs = null  } = params
        console.log(`initFinderGlobalHooks beforeFetch:`, params)
        let _params = {
          ...params,
          page: pageNum,
          page_size: pageSize,
          finderId
        }
        if (qs) {
          _params = {
            ..._params,
            ...JSON.parse(qs)
          }
        }
        return _params
      },
      afterQuery (res) {
        const { list, total_count, count } = res

        return {
          list,
          count: count || total_count
        }
      }
    }
  }
}
